import React, { PropsWithChildren, useState } from 'react';
import styles from './AppLayout.module.sass';
import Header, { HeaderProps } from 'components/common/Header';
import NavSidebar, { NavSidebarProps } from 'components/common/NavSidebar';
import { NextPageWithLayout } from 'types/page';

export interface AppLayoutProps extends PropsWithChildren {
  title?: HeaderProps['title'];
  headerClassName?: HeaderProps['className'];
  sidebarClassName?: NavSidebarProps['className'];
  hideSidebar?: boolean;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  title,
  children,
  headerClassName,
  sidebarClassName,
  hideSidebar = false,
}) => {
  const [visible, setVisible] = useState(false);
  const onOpen = () => setVisible(true);
  const onClose = () => setVisible(false);

  return (
    <div className={styles.page}>
      {!hideSidebar && (
        <NavSidebar
          visible={visible}
          onClose={onClose}
          onOpen={onOpen}
          className={sidebarClassName}
        />
      )}
      <div className={styles.container}>
        <Header title={title} onOpen={onOpen} className={headerClassName} />
        {children}
      </div>
    </div>
  );
};

export default AppLayout;

export const getAppLayout =
  (props: AppLayoutProps): NextPageWithLayout['getLayout'] =>
  // eslint-disable-next-line react/display-name
  (children) =>
    <AppLayout {...props}>{children}</AppLayout>;
